/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCatalogProductDetailPageOption
// ====================================================

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_estimated_shipping_date_estimate_list {
  day: number;
  probability: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_estimated_shipping_date {
  estimate_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_estimated_shipping_date_estimate_list[] | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_shipping_fee {
  /**
   * 배송비 타입
   */
  fee_type: PdpShippingFeeType;
  /**
   * 기본 배송비
   */
  base_fee: number;
  /**
   * 조건부 무료 배송비
   */
  minimum_free_shipping_fee: number | null;
  /**
   * 추가 배송비 문구
   */
  additional_shipping_fee_text: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_shipping_company {
  return_company: PdpShopShippingCompany | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_meta_catalog_product_info {
  id: string;
  is_able_to_buy: boolean;
  /**
   * 상품 url
   */
  pdp_url: string;
  browsing_type: PdpBrowsingType;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_first_order_discount {
  price: number;
  promotion_id: string;
  /**
   * 할인 타입
   */
  discount_type: PdpCouponDiscountType;
  discount_amount: number;
  /**
   * 할인률 (첫구매 할인률)
   */
  discount_rate_bp: number | null;
  min_required_amount: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_coupon_discount_info_list {
  /**
   * 쿠폰 타겟 타입 (ORDER, SHOP, SHOP_WITH_ZONLY, SHOP_GROUP, SHOP_GROUP_WITH_ZONLY, ORDER_ITEM, ORDER_ITEM_GROUP, CATEGORY, DEPARTMENT, SHIPPING_FEE, POINT)
   */
  target_type: string | null;
  /**
   * 할인 타입
   */
  discount_type: PdpCouponDiscountType;
  /**
   * 할인양
   */
  discount_amount: number;
  /**
   * 할인률 (정률 쿠폰의 할인률)
   */
  discount_rate_bp: number | null;
  /**
   * 할인 금액 (정액 쿠폰의 할인 금액)
   */
  discount_amount_of_amount_coupon: number | null;
  /**
   * 최소 주문 금액
   */
  min_required_amount: number;
  /**
   * 최대 할인 금액
   */
  max_discount_amount: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_badge_color {
  normal: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_badge {
  text: string;
  color: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_badge_color | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_color {
  normal: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price {
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_badge | null;
  /**
   * color
   */
  color: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_color;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional_badge {
  text: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional_color {
  normal: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional {
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional_badge | null;
  /**
   * color
   */
  color: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional_color;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price {
  /**
   * 노출 최종가
   */
  final_price: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price;
  /**
   * 노출 최종가 (3중가 표기시 활용)
   */
  final_price_additional: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price_final_price_additional | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_product_promotion_discount_info {
  /**
   * 할인양
   */
  discount_amount: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_max_price_info {
  /**
   * 가격
   */
  price: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_final_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price {
  /**
   * 첫구매가 혜택
   */
  first_order_discount: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_first_order_discount | null;
  /**
   * 쿠폰 할인 정보 리스트
   */
  coupon_discount_info_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_coupon_discount_info_list[] | null;
  /**
   * atf 노출용 최종가 정보
   */
  display_final_price: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_display_final_price;
  /**
   * 지그재그 추가 할인 정보(구. 제트할인가)
   */
  product_promotion_discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_product_promotion_discount_info | null;
  /**
   * 노출 원가 정보
   */
  max_price_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_max_price_info;
  /**
   * 최종 할인 정보
   */
  final_discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price_final_discount_info;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_trait_list {
  /**
   * trait type : EXCLUSIVE, SAMPLE, RAFFLE
   */
  type: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info_bogo_info_badge {
  image_url: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info_bogo_info {
  /**
   * N+1 프로모션 적용을 위해 요구되는 최소 수량 (N값)
   */
  required_quantity: number | null;
  /**
   * 프로모션 할인 타입
   */
  discount_type: PdpBogoDiscountType | null;
  /**
   * 프로모션 할인 금액
   */
  discount_amount: number | null;
  /**
   * 프로모션 할인률
   */
  discount_rate_bp: number | null;
  /**
   * bogo 뱃지
   */
  badge: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info_bogo_info_badge | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info {
  /**
   * 프로모션 ID
   */
  promotion_id: string | null;
  /**
   * 프로모션 TYPE
   */
  promotion_type: PdpPromotionType | null;
  /**
   * N+1 프로모션 정보
   */
  bogo_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info_bogo_info | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_image_list {
  /**
   * 이미지 URL
   */
  url: string | null;
  /**
   * 원본 이미지 URL(도메인 포함)
   */
  origin_url: string;
  /**
   * pdp 썸네일 URL(도메인 포함)
   */
  pdp_thumbnail_url: string | null;
  /**
   * pdp static image url. gif 이미지 로딩속도 개선을 위함
   */
  pdp_static_image_url: string | null;
  /**
   * 이미지 타입
   */
  image_type: PdpCatalogProductImageType;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list_value_list {
  id: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 정적 이미지 URL(webp type)
   */
  static_url: string | null;
  /**
   * 정적 이미지 URL(jpeg type)
   */
  jpeg_url: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list {
  id: string;
  /**
   * 순서
   */
  order: number;
  /**
   * 속성명
   */
  name: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 필수여부
   */
  required: boolean;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 속성 값
   */
  value_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list_value_list[];
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_color {
  normal: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_badge_color {
  normal: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_badge {
  text: string;
  color: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_badge_color | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info {
  /**
   * 가격
   */
  price: number;
  /**
   * color
   */
  color: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_color;
  /**
   * 가격 뱃지 (ex. 쿠폰할인가, 첫구매가, 직잭위크 등 CMS 정보 등)
   */
  badge: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info_badge | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_final_discount_info {
  /**
   * 할인가
   */
  discount_price: number;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price {
  /**
   * 노출 원가 정보
   */
  max_price_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_max_price_info;
  /**
   * 최종 할인 정보
   */
  final_discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price_final_discount_info;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_discount_info {
  color: string | null;
  title: string | null;
  image_url: string | null;
  order: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_shipping_fee {
  /**
   * 배송비 타입
   */
  fee_type: PdpShippingFeeType;
  /**
   * 기본 배송비
   */
  base_fee: number;
  /**
   * 조건부 무료 배송비
   */
  minimum_free_shipping_fee: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_option_list_value_list {
  id: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 정적 이미지 URL(webp type)
   */
  static_url: string | null;
  /**
   * 정적 이미지 URL(jpeg type)
   */
  jpeg_url: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_option_list {
  id: string;
  /**
   * 순서
   */
  order: number;
  /**
   * 속성명
   */
  name: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 필수여부
   */
  required: boolean;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 속성 값
   */
  value_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_option_list_value_list[];
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info {
  id: string;
  /**
   * 상품명
   */
  name: string;
  is_able_to_buy: boolean;
  /**
   * 상품 url
   */
  pdp_url: string;
  /**
   * 배송 타입
   */
  fulfillment_type: PdpCatalogFulfillmentType;
  browsing_type: PdpBrowsingType;
  /**
   * 솔루션사 관리코드
   */
  external_code: string | null;
  /**
   * 상품의 가격 정보
   */
  product_price: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_product_price;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_discount_info | null;
  /**
   * 배송비
   */
  shipping_fee: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_shipping_fee | null;
  option_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info_option_list[];
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_additional_option_list_value_list {
  id: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 정적 이미지 URL(webp type)
   */
  static_url: string | null;
  /**
   * 정적 이미지 URL(jpeg type)
   */
  jpeg_url: string | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_additional_option_list {
  id: string;
  /**
   * 순서
   */
  order: number;
  /**
   * 속성명
   */
  name: string;
  /**
   * 코드
   */
  code: string | null;
  /**
   * 필수여부
   */
  required: boolean;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 속성 값
   */
  value_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_additional_option_list_value_list[];
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_custom_input_option_list {
  /**
   * 상품 옵션명
   */
  name: string;
  /**
   * 필수 여부
   */
  is_required: boolean;
  /**
   * 값 입력 제한
   */
  max_length: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
  order: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_item_attribute_list {
  /**
   * 대응되는 상품 옵션 ID
   */
  id: string;
  /**
   * 속성명
   */
  name: string;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 속성 값 번호
   */
  value_id: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_wms_notification_info {
  /**
   * 재입고 알림 여부
   */
  active: boolean;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list {
  id: string;
  /**
   * 품목명
   */
  name: string;
  /**
   * 품목 값
   */
  price: number;
  /**
   * 품목 값 차액
   */
  price_delta: number;
  /**
   * 쿠폰, Z할인 등 모든 할인가가 반영된 값
   */
  final_price: number;
  /**
   * 품목 코드
   */
  item_code: string | null;
  /**
   * 품목 판매 상태
   */
  sales_status: PdpCatalogSalesStatus;
  /**
   * 품목 노출 상태
   */
  display_status: PdpCatalogItemDisplayStatus;
  /**
   * 남은 재고
   */
  remain_stock: number | null;
  /**
   * 직진 여부
   */
  is_zigzin: boolean | null;
  /**
   * 배송 타입
   */
  delivery_type: PdpDeliveryType | null;
  /**
   * 배송 날짜 문구
   */
  expected_delivery_date: string | null;
  /**
   * 배송 날짜 epochTime
   */
  expected_delivery_time: CrTimestamp | null;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_discount_info | null;
  /**
   * 품목의 부가 속성 리스트
   */
  item_attribute_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_item_attribute_list[];
  /**
   * 재입고 알림 여부
   */
  wms_notification_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list_wms_notification_info | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
  order: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_item_attribute_list {
  /**
   * 대응되는 상품 옵션 ID
   */
  id: string;
  /**
   * 속성명
   */
  name: string;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 속성 값 번호
   */
  value_id: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_wms_notification_info {
  /**
   * 재입고 알림 여부
   */
  active: boolean;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list {
  id: string;
  /**
   * 품목명
   */
  name: string;
  /**
   * 품목 값
   */
  price: number;
  /**
   * 품목 값 차액
   */
  price_delta: number;
  /**
   * 쿠폰, Z할인 등 모든 할인가가 반영된 값
   */
  final_price: number;
  /**
   * 품목 코드
   */
  item_code: string | null;
  /**
   * 품목 판매 상태
   */
  sales_status: PdpCatalogSalesStatus;
  /**
   * 품목 노출 상태
   */
  display_status: PdpCatalogItemDisplayStatus;
  /**
   * 남은 재고
   */
  remain_stock: number | null;
  /**
   * 직진 여부
   */
  is_zigzin: boolean | null;
  /**
   * 배송 타입
   */
  delivery_type: PdpDeliveryType | null;
  /**
   * 배송 날짜 문구
   */
  expected_delivery_date: string | null;
  /**
   * 배송 날짜 epochTime
   */
  expected_delivery_time: CrTimestamp | null;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_discount_info | null;
  /**
   * 품목의 부가 속성 리스트
   */
  item_attribute_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_item_attribute_list[];
  /**
   * 재입고 알림 여부
   */
  wms_notification_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list_wms_notification_info | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
  order: number | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_item_attribute_list {
  /**
   * 대응되는 상품 옵션 ID
   */
  id: string;
  /**
   * 속성명
   */
  name: string;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 속성 값 번호
   */
  value_id: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_wms_notification_info {
  /**
   * 재입고 알림 여부
   */
  active: boolean;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list {
  id: string;
  /**
   * 품목명
   */
  name: string;
  /**
   * 품목 값
   */
  price: number;
  /**
   * 품목 값 차액
   */
  price_delta: number;
  /**
   * 쿠폰, Z할인 등 모든 할인가가 반영된 값
   */
  final_price: number;
  /**
   * 품목 코드
   */
  item_code: string | null;
  /**
   * 품목 판매 상태
   */
  sales_status: PdpCatalogSalesStatus;
  /**
   * 품목 노출 상태
   */
  display_status: PdpCatalogItemDisplayStatus;
  /**
   * 남은 재고
   */
  remain_stock: number | null;
  /**
   * 직진 여부
   */
  is_zigzin: boolean | null;
  /**
   * 배송 타입
   */
  delivery_type: PdpDeliveryType | null;
  /**
   * 배송 날짜 문구
   */
  expected_delivery_date: string | null;
  /**
   * 배송 날짜 epochTime
   */
  expected_delivery_time: CrTimestamp | null;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_discount_info | null;
  /**
   * 품목의 부가 속성 리스트
   */
  item_attribute_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_item_attribute_list[];
  /**
   * 재입고 알림 여부
   */
  wms_notification_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list_wms_notification_info | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_color_image_list {
  is_main: boolean;
  image_url: string | null;
  image_width: number | null;
  image_height: number | null;
  webp_image_url: string | null;
  color_list: string[];
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_store_deal_banner {
  /**
   * 배너 노출 문구 ex. 소호샵 구매하고 100원딜 혜택받기
   */
  title: string;
  /**
   * 안내 문구 ex. 소호샵 상품 10,000원(배송비 제외) 이상 구매 시 주문 가능한 이벤트 상품으로 스토어별 최초 1회만 가능
   */
  guide_text: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_category_list {
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_option_size_recommendation {
  option_recommend_text: string;
  option_value: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_catalog_product {
  /**
   * 상점 ID
   */
  shop_id: number;
  /**
   * 상점의 이름
   */
  shop_name: string;
  /**
   * 상점의 도메인
   */
  shop_main_domain: string;
  id: string;
  /**
   * 상품명
   */
  name: string;
  /**
   * 배송 타입
   */
  fulfillment_type: PdpCatalogFulfillmentType;
  /**
   * 솔루션사 관리코드
   */
  external_code: string | null;
  /**
   * 최소구매수량
   */
  minimum_order_quantity: number;
  /**
   * 최대구매수량
   */
  maximum_order_quantity: number | null;
  /**
   * 쿠폰 상태
   */
  coupon_available_status: PdpCouponAvailableStatus;
  /**
   * 판매 예정 시간
   */
  scheduled_sale_date: CrTimestamp | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_discount_info | null;
  /**
   * 예측 배송기간 정보(from order service)
   */
  estimated_shipping_date: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_estimated_shipping_date | null;
  /**
   * 배송비
   */
  shipping_fee: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_shipping_fee | null;
  /**
   * 배송사
   */
  shipping_company: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_shipping_company | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_managed_category_list[] | null;
  /**
   * 메타 옵션 링크 정보
   */
  meta_catalog_product_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_meta_catalog_product_info | null;
  /**
   * 상품의 가격 정보
   */
  product_price: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_price;
  /**
   * 상품의 특성관련 정보
   */
  trait_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_trait_list[] | null;
  /**
   * 상품 프로모션 정보
   */
  promotion_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info | null;
  /**
   * 상품의 이미지 리스트
   */
  product_image_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_image_list[];
  /**
   * 상품 품목 부가 속성 리스트
   */
  product_option_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list[];
  /**
   * 직진배송에 매칭되는 상품 정보
   */
  matching_catalog_product_info: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info | null;
  /**
   * 상품 품목 부가 속성 리스트
   */
  product_additional_option_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_additional_option_list[] | null;
  /**
   * 사용자 입력 옵션 리스트
   */
  custom_input_option_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_custom_input_option_list[];
  /**
   * 옵션 통합 리스트
   */
  matched_item_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list[];
  /**
   * 직진배송 옵션 리스트
   */
  zigzin_item_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_zigzin_item_list[];
  /**
   * 상품의 추가 품목 리스트
   */
  additional_item_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list[] | null;
  /**
   * 직진 배송만 보기 버튼 노출 플래그
   */
  is_only_zigzin_button_visible: boolean;
  /**
   * 파트너센터에서 등록한 상품 color 정보
   */
  color_image_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_color_image_list[];
  /**
   * 스토어딜 배너
   */
  store_deal_banner: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_store_deal_banner | null;
  /**
   * 카테고리 리스트
   */
  category_list: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_category_list[] | null;
  /**
   * 최소구매수량타입 (PRODUCT, ITEM)
   */
  minimum_order_quantity_type: string | null;
  /**
   * 옵션 사이즈 추천
   */
  option_size_recommendation: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_option_size_recommendation | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_flags {
  /**
   * 단수상품(한번에 하나만 구매할 수 있는 상품)
   */
  is_purchase_only_one_at_time: boolean | null;
  /**
   * 장바구니 버튼 노출 여부
   */
  is_cart_button_visible: boolean | null;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button_text {
  /**
   * 비활성화 케이스에 대한 키 컬러
   */
  disabled: string;
  /**
   * 활성화 케이스에 대한 키 컬러
   */
  enabled: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button_background {
  /**
   * 비활성화 케이스에 대한 키 컬러
   */
  disabled: string;
  /**
   * 활성화 케이스에 대한 키 컬러
   */
  enabled: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button {
  /**
   * 텍스트 키 컬러
   */
  text: GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button_text;
  /**
   * 배경 키 컬러
   */
  background: GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button_background;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info_key_color {
  /**
   * 구매하기 버튼
   */
  buy_button: GetCatalogProductDetailPageOption_pdp_option_info_key_color_buy_button;
  /**
   * atf 영역 할인 정보에 적용되는 색상
   */
  discount_info_of_atf: string;
}

export interface GetCatalogProductDetailPageOption_pdp_option_info {
  /**
   * 입점형 내재화 상품정보
   */
  catalog_product: GetCatalogProductDetailPageOption_pdp_option_info_catalog_product;
  /**
   * PDP 노출 여부 판단 BOOLEAN 값 들
   */
  flags: GetCatalogProductDetailPageOption_pdp_option_info_flags;
  /**
   * PDP 전체적인 컨셉에 활용되는 Key Color
   */
  key_color: GetCatalogProductDetailPageOption_pdp_option_info_key_color;
}

export interface GetCatalogProductDetailPageOption {
  /**
   * 입점형 PDP 상품 옵션 정보
   * catalog_product_detail_page와 동일한 타입을 반환하지만 옵션과 관련된 필드만 채워서 응답한다.
   */
  pdp_option_info: GetCatalogProductDetailPageOption_pdp_option_info | null;
}

export interface GetCatalogProductDetailPageOptionVariables {
  catalog_product_id: string;
  input?: PdpBaseInfoInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCartItemList
// ====================================================

export interface AddCartItemList {
  /**
   * 장바구니 아이템을 추가한다.
   * [error_code]
   * - order_unavailable: (세션 내 zigzag_shop_id가 없는 경우) 주문 기능을 더 이상 사용할 수 없습니다.
   */
  addCartItemList: boolean;
}

export interface AddCartItemListVariables {
  input: AddCartItemListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegisterWmsUserNotification
// ====================================================

export interface RegisterWmsUserNotification_registerWmsUserNotification {
  active: boolean;
}

export interface RegisterWmsUserNotification {
  /**
   * 유저 대상 물류 notification 저장
   */
  registerWmsUserNotification: RegisterWmsUserNotification_registerWmsUserNotification | null;
}

export interface RegisterWmsUserNotificationVariables {
  input: WmsUserNotificationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateOrderSheet
// ====================================================

export interface CreateOrderSheet {
  /**
   * 주문서 임시데이터를 생성한다
   */
  createOrderSheet: string;
}

export interface CreateOrderSheetVariables {
  input: CreateOrderSheetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OptionOrderPromotion
// ====================================================

export interface OptionOrderPromotion {
  /**
   * 프로모션 타입
   */
  promotion_type: OrderPromotionType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OptionItemList
// ====================================================

export interface OptionItemList_discount_info {
  image_url: string | null;
  title: string | null;
  color: string | null;
  order: number | null;
}

export interface OptionItemList_item_attribute_list {
  /**
   * 대응되는 상품 옵션 ID
   */
  id: string;
  /**
   * 속성명
   */
  name: string;
  /**
   * 속성 값
   */
  value: string;
  /**
   * 속성 값 번호
   */
  value_id: string;
}

export interface OptionItemList_wms_notification_info {
  /**
   * 재입고 알림 여부
   */
  active: boolean;
}

export interface OptionItemList {
  id: string;
  /**
   * 품목명
   */
  name: string;
  /**
   * 품목 값
   */
  price: number;
  /**
   * 품목 값 차액
   */
  price_delta: number;
  /**
   * 쿠폰, Z할인 등 모든 할인가가 반영된 값
   */
  final_price: number;
  /**
   * 품목 코드
   */
  item_code: string | null;
  /**
   * 품목 판매 상태
   */
  sales_status: PdpCatalogSalesStatus;
  /**
   * 품목 노출 상태
   */
  display_status: PdpCatalogItemDisplayStatus;
  /**
   * 남은 재고
   */
  remain_stock: number | null;
  /**
   * 직진 여부
   */
  is_zigzin: boolean | null;
  /**
   * 배송 타입
   */
  delivery_type: PdpDeliveryType | null;
  /**
   * 배송 날짜 문구
   */
  expected_delivery_date: string | null;
  /**
   * 배송 날짜 epochTime
   */
  expected_delivery_time: CrTimestamp | null;
  /**
   * 옵션 종류  (BASIC, ADDITIONAL)
   */
  option_type: string | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: OptionItemList_discount_info | null;
  /**
   * 품목의 부가 속성 리스트
   */
  item_attribute_list: OptionItemList_item_attribute_list[];
  /**
   * 재입고 알림 여부
   */
  wms_notification_info: OptionItemList_wms_notification_info | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum OrderPromotionType {
  BOGO = "BOGO",
  BOGO_DISCOUNT = "BOGO_DISCOUNT",
  CONDITION_DEAL = "CONDITION_DEAL",
  CUSTOM_PRICE = "CUSTOM_PRICE",
  EXPERIENCE_GROUP = "EXPERIENCE_GROUP",
  FIRST_ORDER = "FIRST_ORDER",
  RAFFLE = "RAFFLE",
  SHIPPING_FEE = "SHIPPING_FEE",
}

export enum PdpBogoDiscountType {
  AMOUNT = "AMOUNT",
  RATE = "RATE",
}

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum PdpCatalogFulfillmentType {
  DIGITAL_DELIVERY = "DIGITAL_DELIVERY",
  MERCHANT = "MERCHANT",
  ON_SITE = "ON_SITE",
  VENDOR_FLEX = "VENDOR_FLEX",
  ZIGZIN = "ZIGZIN",
}

export enum PdpCatalogItemDisplayStatus {
  HIDDEN = "HIDDEN",
  VISIBLE = "VISIBLE",
}

export enum PdpCatalogProductImageType {
  CONTENT = "CONTENT",
  MAIN = "MAIN",
  SUB = "SUB",
}

export enum PdpCatalogSalesStatus {
  CLOSED = "CLOSED",
  ON_SALE = "ON_SALE",
  PREPARING = "PREPARING",
  SOLD_OUT = "SOLD_OUT",
  SUSPENDED = "SUSPENDED",
}

export enum PdpCouponAvailableStatus {
  COUPON_AVAILABLE = "COUPON_AVAILABLE",
  COUPON_ISSUED = "COUPON_ISSUED",
  COUPON_NOT_APPLICABLE = "COUPON_NOT_APPLICABLE",
  COUPON_UNAVAILABLE = "COUPON_UNAVAILABLE",
  UNKNOWN = "UNKNOWN",
}

export enum PdpCouponDiscountType {
  AMOUNT = "AMOUNT",
  RATE = "RATE",
}

export enum PdpDeliveryType {
  FAST = "FAST",
  GENERAL = "GENERAL",
  VENDOR_FLEX = "VENDOR_FLEX",
  ZIGZIN = "ZIGZIN",
}

export enum PdpPromotionType {
  BOGO = "BOGO",
  BOGO_DISCOUNT = "BOGO_DISCOUNT",
  FIRST_ORDER = "FIRST_ORDER",
  RAFFLE = "RAFFLE",
}

export enum PdpShippingFeeType {
  CHARGED = "CHARGED",
  CONDITIONAL_FREE = "CONDITIONAL_FREE",
  FREE = "FREE",
}

export enum PdpShopShippingCompany {
  CJ = "CJ",
  ETC = "ETC",
  HANJIN = "HANJIN",
  ILYANG = "ILYANG",
  LOGEN = "LOGEN",
  LOGIS = "LOGIS",
  LOTTE = "LOTTE",
  POSTAL = "POSTAL",
}

export enum WmsUserNotificationType {
  RE_WAREHOUSED_IN = "RE_WAREHOUSED_IN",
}

/**
 * 장바구니 추가할 아이템의 입력
 */
export interface AddCartItemListInput {
  product_item_quantity_list: AddCartProductItemQuantityInput[];
}

/**
 * 상품 레코드 ID, 추가 옵션 정보와 아이템별 장바구니 수량 변동량의 배열
 */
export interface AddCartProductItemQuantityInput {
  product_item_id: string;
  quantity_delta: number;
  additional_option_detail_list?: ProductAdditionalOptionInput[] | null;
  grouping_required_quantity?: number | null;
  promotion_item_group_key?: string | null;
  funnel_info?: FunnelInfoInput | null;
  product_id?: string | null;
}

/**
 * createOrderSheet의 입력
 */
export interface CreateOrderSheetInput {
  order_item_list: CreateOrderSheetOrderItemInput[];
  selected_user_account_coupon_id_list?: string[] | null;
  is_same_day_shipping?: boolean | null;
}

/**
 * createOrderSheet의 상품정보
 */
export interface CreateOrderSheetOrderItemInput {
  product_item_id: string;
  price: number;
  quantity: number;
  additional_option_detail_list?: ProductAdditionalOptionInput[] | null;
  cart_item_hash?: string | null;
  grouping_required_quantity?: number | null;
  promotion_applied_info?: PromotionAppliedInfoInput | null;
  funnel_info?: FunnelInfoInput | null;
  cart_item_id?: string | null;
  coupon_discount_amount?: number | null;
}

/**
 * 퍼널 정보의 입력
 */
export interface FunnelInfoInput {
  type: string;
}

export interface PdpBaseInfoInput {
  catalog_product_id: string;
  source?: string | null;
  web_uuid?: string | null;
  entry_source_type?: string | null;
}

/**
 * 상품에 추가적으로 필요한 옵션 정보
 */
export interface ProductAdditionalOptionInput {
  name: string;
  option_code?: string | null;
  value: string;
  value_code?: string | null;
}

/**
 * 주문할 상품의 프로모션 적용 정보
 */
export interface PromotionAppliedInfoInput {
  promotion_applied_discount_price: number;
  promotion_id: string;
  promotion_type: OrderPromotionType;
  promotion_item_group_key?: string | null;
}

export interface WmsUserNotificationInput {
  notification_type: WmsUserNotificationType;
  product_item_id: string;
  active: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
